import backofficeService from "@/api/backoffice";
import publicService from "@/api/public";

export default {
  getAll() { return backofficeService.Api().get("invoiceExitGuard").then(r => r.data); },
  create(data) { return backofficeService.Api().post("invoiceExitGuard", data).then(r => r.data); },
  update(id, data) { return backofficeService.Api().put(`invoiceExitGuard/${id}`, data).then(r => r.data); },
  remove(id) { return backofficeService.Api().delete(`invoiceExitGuard/${id}`).then(r => r.data); },
  dashboard(params) { return backofficeService.Api().get("invoiceExitGuard/dashboard", { params }).then(r => r.data); },
  cancelExitPrint(invoiceId) { return backofficeService.Api().post(`invoice/${invoiceId}/exit-print-cancel`).then(r => r.data); },
  authenticate(accessCode, pin) { return publicService.Api().post("public/invoiceExitGuard/authenticate", { accessCode, pin }).then(r => r.data); },
  scan(accessCode, token, payload) { return publicService.Api().post("public/invoiceExitGuard/scan", { accessCode, token, payload }).then(r => r.data); },
  link(accessCode) { return `${window.location.origin}/g/${encodeURIComponent(accessCode)}`; },
};
